<div class="bg-alt md:pt-[95px] pb-20 pt-[55px] relative">
    <div class="absolute h-[35px] md:h-[45px] w-full overflow-hidden top-0">
        <div
            class="w-full scale-x-[1.8] sm:scale-x-[1.3] left-50% absolute bg-[radial-gradient(ellipse_at_top,_#fff_60%,_#f6f6f8_60.2%)] bottom-0 dark:bg-[radial-gradient(ellipse_at_top,_rgba(22_33_52)_60%,_transparent_60%)] h-full"></div>
    </div>
    <div class="container">
        <ng-content />
    </div>
</div>
